import {EnvironmentType} from "@app/enums/enums";


export const environment = {
  production: false,
  apiUrl: 'https://themaapidev.clavisco.com/',
  name: `ThuleCR`,
  type: EnvironmentType.Development,
  env: 'Development',
  recatchaSiteKey: '6LcMlsIpAAAAAKBfVDv-HijjIAiyEvsmPzlcTDZE',
  LogRocketId: ''
};
